export function campuses(state) {
	return state.campuses;
}
